import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  CONNECTIVITY_STATE,
  getConnectivitySnapshot,
  getConnectivityState,
  isEffectivelyOffline,
  isBrowserReportedOnline,
  isConnectivityHealthy,
  startConnectivityManager,
  subscribeConnectivity,
} from "../helpers/connectivity";

const ConnectivityContext = createContext(null);

export function ConnectivityProvider({ children }) {
  const [snapshot, setSnapshot] = useState(() => getConnectivitySnapshot());

  useEffect(() => {
    startConnectivityManager();

    return subscribeConnectivity(() => {
      setSnapshot(getConnectivitySnapshot());
    });
  }, []);

  const value = useMemo(
    () => ({
      state: snapshot.state,
      isOffline: isEffectivelyOffline(),
      isConnectivityHealthy: isConnectivityHealthy(),
      browserOnline: snapshot.browserOnline,
      consecutiveSuccesses: snapshot.consecutiveSuccesses,
      consecutiveFailures: snapshot.consecutiveFailures,
    }),
    [snapshot],
  );

  return (
    <ConnectivityContext.Provider value={value}>
      {children}
    </ConnectivityContext.Provider>
  );
}

export function useConnectivity() {
  const context = useContext(ConnectivityContext);
  if (!context) {
    return {
      state: getConnectivityState(),
      isOffline: isEffectivelyOffline(),
      isConnectivityHealthy: isConnectivityHealthy(),
      browserOnline: isBrowserReportedOnline(),
      consecutiveSuccesses: 0,
      consecutiveFailures: 0,
    };
  }
  return context;
}

export { CONNECTIVITY_STATE };
